const kochartechLogo = require("./images/ktech_logo.png");

const User_Email_Tin_Upload_Rights = [
  "abhishek.vashisht@maxicus.com",
  "sarbjeet.singh@igzy.com",
];

const User_Email_Tin_Release_Rights = [
  "sarbjeet.singh@igzy.com",
];

const Trf_Edit_Right = [
  "abhishek.vashisht@maxicus.com",
  "sarbjeet.singh@igzy.com",
];

const Reject_Rights = [
  "abhishek.vashisht@maxicus.com",
  "sarbjeet.singh@igzy.com"
];

const DOCUMENT_RIGHTS = [
  "jahnvi.rampal@maxicus.com",
  "samiksha.bali@kochartech.com",
  "jasleen.mand@kochartech.com",
  "satinder.palsingh@kochartech.com",
];
const AI_SERVICE_RIGHTS = [
  "sarbjot.singh@kochartech.com",
  "ankita.chug@kochartech.com",
  "bhavya.khanna@kochartech.com",
  "sarbjeet.singh@igzy.com",
  "vishal.mahajan@kochartech.com",
];

const rights = ["hr", "admin", "central_hr"];

// const Skill_TRF_Id = "64783cf4d5516c17f50693ed"; //Local
// const Skill_TRF_Id = "64783cf4d5516c17f50693ed"; //UAT
const Skill_TRF_Id = "648c9f0319a3ca3c3d1fa5d0"; //Production

//in kb

const IMAGE_SIZE = 100;
const DOC_SIZE = 1024;
const VIDEO_SIZE = 11264;
const DOMAIN = "dh.kochartech.com";

module.exports = {
  User_Email_Tin_Upload_Rights,
  User_Email_Tin_Release_Rights,
  Trf_Edit_Right,
  Skill_TRF_Id,
  IMAGE_SIZE,
  DOC_SIZE,
  VIDEO_SIZE,
  kochartechLogo,
  DOMAIN,
  rights,
  Reject_Rights,
  DOCUMENT_RIGHTS,
  AI_SERVICE_RIGHTS
};
